// src/components/Users/DeleteConfirmModal.js
import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, user, loading = false }) => {
  if (!isOpen || !user) return null;

  const handleConfirm = () => {
    onConfirm(user.id);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        style={{maxWidth: '400px'}}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2 className="modal-title" style={{color: '#dc2626'}}>
            Delete User
          </h2>
          <button
            onClick={onClose}
            className="modal-close"
            disabled={loading}
          >
            <X size={20} />
          </button>
        </div>

        <div style={{padding: '0 1.5rem 1.5rem 1.5rem'}}>
          {/* Warning Icon */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '1rem'
          }}>
            <div style={{
              background: '#fef2f2',
              borderRadius: '50%',
              padding: '1rem',
              width: '64px',
              height: '64px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <AlertTriangle size={32} color="#dc2626" />
            </div>
          </div>

          {/* Confirmation Text */}
          <div style={{textAlign: 'center', marginBottom: '1.5rem'}}>
            <p style={{
              fontSize: '1rem',
              color: '#374151',
              marginBottom: '0.5rem',
              fontWeight: '500'
            }}>
              Are you sure you want to delete this user?
            </p>

            <div style={{
              background: '#f9fafb',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              padding: '1rem',
              margin: '1rem 0'
            }}>
              <p style={{fontWeight: '600', color: '#1f2937', marginBottom: '0.25rem'}}>
                {user.full_name}
              </p>
              <p style={{fontSize: '0.875rem', color: '#6b7280', marginBottom: '0.25rem'}}>
                @{user.username}
              </p>
              {user.email && (
                <p style={{fontSize: '0.75rem', color: '#9ca3af'}}>
                  {user.email}
                </p>
              )}
            </div>

            <p style={{
              fontSize: '0.875rem',
              color: '#dc2626',
              fontWeight: '500'
            }}>
              This action cannot be undone.
            </p>
          </div>

          {/* Buttons */}
          <div className="modal-actions">
            <button
              type="button"
              onClick={onClose}
              className="btn-secondary"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleConfirm}
              disabled={loading}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                background: '#dc2626',
                color: 'white',
                padding: '0.5rem 1rem',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
                minWidth: '100px',
                justifyContent: 'center'
              }}
              onMouseOver={(e) => e.target.style.background = '#b91c1c'}
              onMouseOut={(e) => e.target.style.background = '#dc2626'}
            >
              {loading ? (
                <>
                  <div className="loading-spinner" style={{width: '16px', height: '16px'}}></div>
                  Deleting...
                </>
              ) : (
                'Delete User'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;